module.exports = __webpack_public_path__ + "img/fmkVTfSP.dc259e6c.svg";